<template>
	<button :class="['button', { disabled }]" @click="doAction" @keyup.enter="doAction" role="button">
		<slot></slot>
	</button>
</template>

<script>
import soundFx from '@/mixins/sound-fx';

export default {
	name: 'Button',
	mixins: [soundFx],
	props: {
		action: {
			type: Function,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	methods: {
		doAction() {
			if (!this.disabled) {
				this.action();
			} else {
				// this.shake();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.button {
		display: block;
		padding: 2ch 2.5ch 1.75ch;
		position: relative;

		font-family: $body-font-script;
		font-size: $font-size-lg;
		letter-spacing: $letter-spacing-script;
		text-transform: uppercase;
		line-height: 1;
		color: $off-white-dark;

		background: $background-color;
		border: 0;
		border-radius: 39% 61% 61% 39% / 55% 52% 48% 45%;
		transition: all $ui-transition-duration;

		cursor: pointer;

		@include mobile { font-size: $font-size-sm; }

		.btn-bg { position: absolute; }

		&.disabled {
			color: lighten($primary-color-dark, 30%);
			background: $primary-color-dark;
			cursor: not-allowed;

			&:hover {
				border-radius: 39% 61% 61% 39% / 55% 52% 48% 45%;
				color: lighten($primary-color-dark, 30%);
			}
		}

		&:focus,
		&:active,
		&:hover {
			outline: none;
			color: $primary-color;
			border-radius: 62% 38% 32% 68% / 48% 52% 48% 52%;
		}

		&.sidebar-info-btn {
			border-radius: 50%;
			height: 40px;
			width: 40px;
			color: $primary-color-dark;
			border: dashed 2.5px $primary-color-dark;
			font-family: $body-font-bold;
			font-size: 20px;
			letter-spacing: 0em;
			text-transform: lowercase;
			background: transparent;
			padding: 0;
			margin-bottom: 10%;

			@include mobile {
				color: $background-color;
				border-color: $background-color;
			}

			&:hover {
				color: $primary-color-light;
				border-color: $primary-color-light;
			}
		}

		&.slider-info-btn {
			position: absolute;
			border-radius: 50%;
			padding: 0;
			height: $slider-info-btn-size;
			width: $slider-info-btn-size;
			font-family: $body-font;
			font-size: $font-size-sm;
			letter-spacing: -.05em; // to center question mark
			right: 0;
			top: 0;
			bottom: 0;
			margin: auto 10px;
			background: $body-txt-color;
			color: $off-white;

			@include mobile { margin: auto 1ch auto 0; }
		}

		&.play-again,
		&.popup-btn {
			color: $background-color;
			background: $off-white-dark;
		}

		&.close-btn {
			padding: 2%;
			background-color: $primary-color;
			border: 8px $primary-color solid;
			border-radius: 50%;
			background-image: url('~@/assets/images/close-icon.svg');
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
			z-index: $z-top;

			&:hover {
				border-color: $primary-color-light;
				background-color: $primary-color-light;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/base/Button.vue